import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  reasonAndDischargeCSS: {
    marginTop: "20px",
  },
}));

export default useStyles;
